'use client';
import InternalInputFormatReact from 'input-format/react';
import React, { type ForwardRefExoticComponent, type PropsWithoutRef, type RefAttributes } from 'react';

export type FormatInputProps = Omit<React.ComponentProps<typeof InternalInputFormatReact>, 'size'>;

export const FormatInput = InternalInputFormatReact as ForwardRefExoticComponent<PropsWithoutRef<FormatInputProps> & RefAttributes<HTMLInputElement>>;
